import React, { useState, useMemo, useEffect } from "react";
import AtlasStopMap from "./AtlasStopMap";
import PropTypes from "prop-types";
import { lockScrollbar, unlockScrollbar } from "./utils";
import { useTranslate } from "../../translate";

function AtlasStopModal(props) {
    const { title, address, stop, closeModal, website, phone } = props;
    const [viewport, setViewport] = useState(null);
    const { lat: latitude, lon: longitude } = stop.coords;
    const translate = useTranslate();
    const stopId = stop.id;
    const marker = useMemo(
        () => ({
            id: stopId,
            latitude,
            longitude,
        }),
        [stopId, latitude, longitude],
    );

    useEffect(() => {
        lockScrollbar();
        return () => {
            unlockScrollbar();
        };
    }, []);

    useEffect(() => {
        setViewport({
            zoom: 11,
            latitude: marker.latitude,
            longitude: marker.longitude,
        });
    }, [marker]);

    if (!viewport) {
        return null;
    }

    return (
        <div className="trpr-atlas-stop-modal">
            <header className="trpr-atlas-stop-modal__header">
                <span className="trpr-atlas-stop-modal__title">{title}</span>
                <p className="trpr-atlas-stop-modal__address">{address}</p>
                <ul className="trpr-atlas-stop-modal__links">
                    {phone && (
                        <li>
                            <a href={`tel:${phone}`}>
                                <span>{phone}</span>
                            </a>
                        </li>
                    )}
                    <li>
                        <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={`https://www.google.com/maps/search/?api=1&query=${stop.coords.lat},${stop.coords.lon}`}
                        >
                            <span>{translate("Google Maps")}</span>
                        </a>
                    </li>
                </ul>
                <button type="button" onClick={closeModal} className="trpr-atlas-stop-modal__close-btn">
                    <i className="trpr__icon-close"></i>
                </button>
            </header>
            <div className="trpr-atlas-stop-modal__map">
                <AtlasStopMap
                    website={website}
                    viewport={viewport}
                    onViewportChange={setViewport}
                    height="100%"
                    marker={marker}
                />
            </div>
            {website && (
                <a
                    className="trpr-atlas-stop-modal__map-website"
                    target="_blank"
                    href={website}
                    rel="noopener noreferrer"
                >
                    <i className="trpr__icon-web"></i>
                    <span>{translate("Visit Website")}</span>
                </a>
            )}
        </div>
    );
}
AtlasStopModal.defaultProps = {
    closeModal: () => {},
};
AtlasStopModal.propTypes = {
    stop: PropTypes.object.isRequired,
};

export default AtlasStopModal;
